import { render, staticRenderFns } from "./StockMovementDetailModal.vue?vue&type=template&id=49b9750b&scoped=true&"
import script from "./StockMovementDetailModal.vue?vue&type=script&lang=js&"
export * from "./StockMovementDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./StockMovementDetailModal.vue?vue&type=style&index=0&id=49b9750b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b9750b",
  null
  
)

export default component.exports